module.exports = __webpack_public_path__ + "img/charger.669f1039.svg";